import React from 'react';
import { useTranslation } from 'react-i18next';
import './PartnersSection.css';

const PartnersSection: React.FC = () => {
  const { t } = useTranslation();
  
  const organizers = [
    {
      name: t('partners.rotaryClub.name'),
      logo: '/Rotary Club Peja Logo.png',
      description: t('partners.rotaryClub.description'),
      type: 'organizer'
    },
    {
      name: t('partners.university.name'),
      logo: '/Haxhi Zeka Logo.png',
      description: t('partners.university.description'),
      type: 'organizer'
    }
  ];


  return (
    <section className="partners-section section">
      <div className="container">
        <div className="partners-header text-center">
          <h2>{t('partners.title')}</h2>
          <p>{t('partners.subtitle')}</p>
        </div>

        <div className="organizers-section">
          <div className="partners-grid organizers-grid">
            {organizers.map((partner, index) => (
              <div key={index} className="partner-card organizer-card">
                <div className="partner-logo">
                  <img 
                    src={partner.logo} 
                    alt={partner.name}
                    onError={(e) => {
                      e.currentTarget.src = '/images/placeholder-logo.png';
                    }}
                  />
                </div>
                <div className="partner-info">
                  <h4 className="partner-name">{partner.name}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
